import { FLOW_FRAMES_PORT, type FlowChainSlot, type FlowNodeInput } from "@/types/flow"

/** Слоты, которыми панель перехода пользуется как первым и последним кадром. */
export function frameChainSlots(firstLabel: string, lastLabel: string): FlowChainSlot[] {
  return [
    { position: 0, media: "image", label: firstLabel },
    { position: 1, media: "image", label: lastLabel },
  ]
}

/** Входы порта frames. Номер слота уже лежит на ребре. */
export function frameSlotInputs(inputs: readonly FlowNodeInput[]): FlowNodeInput[] {
  return inputs.filter((input) => input.target_port === FLOW_FRAMES_PORT)
}
